import React from "react";
import { EventDTO } from "utils/helpers/models/common/event.dto";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { ReactComponent as LocationIcon } from "assets/images/common/svgs/locationIcon.svg";
import SessionDateBadge from "components/NextSession/SessionDateBadge";

interface EventCardProps {
  event: EventDTO;
  onClick: () => void;
}

const EventCard: React.FC<EventCardProps> = ({ event, onClick }) => {
  const attendingCount = event?.eventSubscriptions?.length || 0;

  const renderAttendingCount = () => {
    if (!attendingCount || attendingCount <= 0) {
      return null;
    }

    if (attendingCount > 3) {
      return (
        <span className="text-xs text-darkYellowText ml-3">3+ attendees</span>
      );
    }

    return (
      <span className="text-xs text-darkYellowText ml-3">
        {attendingCount} {attendingCount === 1 ? "attendee" : "attendees"}
      </span>
    );
  };

  return (
    <div
      onClick={onClick}
      className="p-3 bg-white rounded-xl border border-borderColor cursor-pointer"
    >
      <div className="relative">
        <img
          src={
            event.eventPicsUrl?.[0]?.fileDownloadUri
              ? concatPathWithBackendUrl(event.eventPicsUrl[0].fileDownloadUri)
              : editProfilePicUser
          }
          alt={event.title}
          className="w-full h-32 object-cover rounded-xl"
        />
        <div className="">
          <SessionDateBadge sessions={event?.workshopSessions || []} />
        </div>
      </div>
      <div className="py-2">
        <h3 className="text-sm font-semibold text-blackie">{event.title}</h3>
        <div className="flex justify-between items-center  w-full my-2">
          <div className="text-xs font-medium text-blackie bg-fade rounded-md px-2 py-1">
            {event.isSession ? "Session" : "Workshop"}
          </div>
          <div className="text-xs text-darkYellowText">
            {event.entryFee > 0 ? `$${event.entryFee}` : "Free"}
          </div>
        </div>
        {/* <div className="flex items-center pb-1">
          {attendingCount > 0 &&
            event?.eventSubscriptions &&
            Array.isArray(event.eventSubscriptions) &&
            event.eventSubscriptions.length > 0 && (
              <div className="flex items-center">
                {event.eventSubscriptions
                  .slice(0, 3)
                  .map((subscription: any, index: number) => (
                    <img
                      key={index}
                      src={
                        subscription?.profilePicUrl?.fileDownloadUri
                          ? concatPathWithBackendUrl(
                              subscription.profilePicUrl.fileDownloadUri
                            )
                          : editProfilePicUser
                      }
                      alt="Attendee"
                      className="w-7 h-7 -mr-2 rounded-full border-2 border-white"
                    />
                  ))}
              </div>
            )}
          {renderAttendingCount()}
        </div> */}
        <div className="text-xs text-[#807A7A]  flex items-center gap-2">
          <div>
            <LocationIcon className="w-4" />
          </div>
          <span>{event.location}</span>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
